// Centralized dropdown options for the SCS "Description of Studies" wizard.
//
// TODO: replace the placeholder ("Option 1"/"Option 2"/...) lists below with the
// real option values once they are known. Everything a dropdown reads should live
// here so the swap is a single-file change.

// Generic placeholder options reused wherever the real values are not yet known.
export const SCS_PLACEHOLDER_OPTIONS = ["Option 1", "Option 2", "Option 3"];

// Section A — study rows.
// TODO: replace with the real study types.
export const SCS_STUDY_TYPE_OPTIONS = [...SCS_PLACEHOLDER_OPTIONS];
export const SCS_STUDY_STATUS_OPTIONS = ["Complete", "Ongoing"];

// Section B — groupings.
// TODO: replace with the real grouping table names.
export const SCS_GROUPING_TABLE_OPTIONS = [...SCS_PLACEHOLDER_OPTIONS];
export const SCS_ADDITIONAL_GROUPING_TABLE_OPTIONS = [
  ...SCS_PLACEHOLDER_OPTIONS,
];

// Section D — comparisons.
export const SCS_COMPARISON_TYPE_OPTIONS = [
  "Non-Comparative",
  "Comparative",
  "Dose-Finding",
];
// Treatment group names (Q8) are free text; Q9's Treatment/Comparator
// dropdowns are built from whatever was typed there, so there is no static
// option list for them.
export const SCS_TREATMENT_GROUP_ROLE_OPTIONS = ["Treatment", "Comparator"];
